/**
 * Значение `ssr` для `loadable()` без серверного рендера.
 *
 * Не заменяй на литерал `ssr: false`. `@swc/plugin-loadable-components` с версии 11.8.0
 * пропускает вызовы с этим литералом. Тогда SSR падает с ошибкой
 * «SSR requires `@loadable/babel-plugin`» и страница отдаёт 500.
 * Константу удали после выхода плагина с исправлением:
 * https://github.com/swc-project/plugins/issues/655
 */
export const NO_SSR = false;
